/* eslint-disable prettier/prettier */
export default {
  removeMask: (value: string): string => value.replace(/\D/g, ''),
  formatReal: (v: number): string => v.toLocaleString('pt-br', { minimumFractionDigits: 2 }),
};
